"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bannerDetail = bannerDetail;
exports.deleteBanner = deleteBanner;
exports.deletePage = deletePage;
exports.deleteSort = deleteSort;
exports.fullList = fullList;
exports.getLink = getLink;
exports.getList = getList;
exports.getModuleList = getModuleList;
exports.moduleDetail = moduleDetail;
exports.queryComponent = queryComponent;
exports.querySubComponent = querySubComponent;
exports.saveModules = saveModules;
exports.saveOrUpdate = saveOrUpdate;
exports.saveOrUpdateBanner = saveOrUpdateBanner;
exports.updateColor = updateColor;
exports.updateSort = updateSort;
exports.updateStatus = updateStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function getList(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/page/list',
    method: 'get',
    params: params
  });
}
function saveOrUpdate(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/page/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function deletePage(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/page/delete',
    method: 'post',
    data: data
  });
}
function getLink(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/page/getLink',
    method: 'get',
    params: params
  });
}
function getModuleList(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/list',
    method: 'get',
    params: params
  });
}
function updateColor(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/page/updateColor',
    method: 'post',
    data: data
  });
}
function updateStatus(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/updateStatus',
    method: 'post',
    data: data
  });
}
function updateSort(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/updateSort',
    method: 'post',
    data: data
  });
}
function deleteSort(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/delete',
    method: 'post',
    data: data
  });
}
function queryComponent(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/queryComponent',
    method: 'get',
    params: params
  });
}
function querySubComponent(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/querySubComponent',
    method: 'get',
    params: params
  });
}
function saveModules(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/save',
    method: 'post',
    data: data
  });
}
function moduleDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/detail/list',
    method: 'get',
    params: params
  });
}
function bannerDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/detail/detail',
    method: 'get',
    params: params
  });
}
function saveOrUpdateBanner(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/detail/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function deleteBanner(data) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/detail/delete',
    method: 'post',
    data: data
  });
}
function fullList(params) {
  return (0, _request.default)({
    url: '/portal/system/decorate/module/activity/fullList',
    method: 'get',
    params: params
  });
}